import { useMemo } from 'react'
import * as THREE from 'three'
import { CaixaArredondada } from '../componentes/CaixaArredondada'

/** Laranja da cinta de poliéster, usada nas fitas e nas cintas dos equipamentos. */
export const COR_CINTA_POLIESTER = '#f97316'

/** Segmento de cinta têxtil tensionada 3D entre dois pontos no espaço. */
export function FitaTensionada({
  de,
  para,
  largura = 0.045,
  espessura = 0.004,
  cor = COR_CINTA_POLIESTER,
}: {
  de: [number, number, number]
  para: [number, number, number]
  largura?: number
  espessura?: number
  cor?: string
}) {
  const delta = useMemo(() => new THREE.Vector3(para[0] - de[0], para[1] - de[1], para[2] - de[2]), [de, para])
  const comp = delta.length()
  const q = useMemo(() => {
    if (comp < 0.001) return new THREE.Quaternion()
    return new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 1, 0), delta.clone().normalize())
  }, [delta, comp])

  if (comp < 0.001) return null

  const meio: [number, number, number] = [
    (de[0] + para[0]) / 2,
    (de[1] + para[1]) / 2,
    (de[2] + para[2]) / 2,
  ]

  return (
    <mesh position={meio} quaternion={[q.x, q.y, q.z, q.w]}>
      <CaixaArredondada args={[largura, comp, espessura]} />
      <meshStandardMaterial color={cor} roughness={0.78} />
    </mesh>
  )
}
